import React from 'react';
import { Button } from 'react-bootstrap';
import './Banner.css'
import Type from './Type/Type';

const Banner = () => {
    return (
        <div>

            <div class="context">
                <h1 className='banner-name mb-3'>I'm Mohammad Fahim Hossain</h1>
                <Type></Type>
                <a className='banner-btn mt-3' href="https://drive.google.com/u/0/uc?id=1gI8T-cGr3gS3TX8eSEs0tdp0Y8uNjg6L&export=download"><Button variant='outline-light banner-btn'>resume</Button></a>



            </div>


            <div class="area" >
                <ul class="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div >
        </div>
    );
};

export default Banner;